var render = function render(){var _vm=this,_c=_vm._self._c;return _c('extrato-cliente')
}
var staticRenderFns = []

export { render, staticRenderFns }